<template>
  <div class="mb-2">
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="createAttachment"
      title="ANEXO"
    >
      <form v-on:submit="createAttachment">
        <div class="row">
          <div class="col-md-12 pt-0 pb-0">
            Selecione o anexo
            <input id="attachment" class="form-control-file" type="file" />
            <p class="mb-0 mt-3 text-info-img">
              Tamanho máximo <strong>10MB</strong>
            </p>
            <p class="text-info-img">
              Formatos: <strong>PDF, JPG, JPEG, PJPEG</strong> e
              <strong>PNG</strong>
            </p>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <label>Descrição</label>
            <textarea v-model="description" rows="3" class="form-control" />
          </div>
          <div class="col-md-12 pt-1 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 pb-0 text-right">
            <v-btn class="btn-save" type="submit" :disabled="loading"
              >ADICIONAR</v-btn
            >
          </div>
        </div>
      </form>
    </b-modal>
    <div class="row">
      <div class="col-md-6 pt-0 pb-0">
        <h6>ANEXOS</h6>
      </div>
      <div class="col-md-6 pt-0 pb-0 text-right">
        <v-btn class="btn-save" @click="$bvModal.show('createAttachment')">
          <i class="fas fa-paperclip mr-2"></i>

          ANEXAR ARQUIVO
        </v-btn>
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="mt-2">
        <div v-if="attachments.length == 0" class="v-clean p-2 text-center">
          Sem resultados!
        </div>
        <table v-if="attachments.length > 0" class="table table-sm">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Tipo</th>
              <th>Adicionado por</th>
              <th>Ver anexo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in attachments" :key="key">
              <td>
                {{ item.description ? item.description : "Não informado" }}
              </td>
              <td>
                <small v-if="item.type == 'application/pdf'">PDF</small>
                <small v-if="item.type != 'application/pdf'">Imagem</small>
              </td>
              <td>
                {{
                  professionalClassCouncilValue({
                    id: item.user_professional_class_council_id,
                    name: item.user_name,
                    value: item.user_professional_class_council_value,
                    cpf: item.user_cpf,
                    office: item.user_office,
                  })
                }}
              </td>
              <td>
                <b-modal
                  size="xl"
                  no-close-on-backdrop
                  hide-footer
                  :id="`attachments_${key}`"
                  title="ANEXO"
                >
                  <img :src="item.attachment_url" class="d-block w-100" />
                </b-modal>
                <v-btn
                  v-if="item.type == 'application/pdf'"
                  class="v-primary m-1"
                  x-small
                >
                  <a
                    class="text-white"
                    target="_blank"
                    :href="item.attachment_url"
                    >Abrir</a
                  >
                </v-btn>
                <v-btn
                  v-if="item.type != 'application/pdf'"
                  x-small
                  class="btn-annotation m-1"
                  @click="$bvModal.show(`attachments_${key}`)"
                >
                  <i class="fas fa-eye mr-1"></i> VISUALIZAR
                </v-btn>
                <confirmation-dialog
                  class="ml-1"
                  small
                  message-title="APAGAR?"
                  message-body="Deseja realmente apagar o anexo?"
                  open-class="btn-delete"
                  open-left-icon="fa-trash"
                  open-text="APAGAR"
                  @yes="deleteAttachment(item.id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../Components/ConfirmationDialog";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

export default {
  name: "Attachments",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    semiology_form_question_answer_id: [String, Number],
  },
  data() {
    return {
      loading: false,
      description: "",
      errors: [],
      attachments: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    professionalClassCouncilValue,
    retrieve() {
      this.getAttachments();
    },
    async getAttachments() {
      try {
        this.loading = true;

        const { semiology_form_question_answer_id } = this;

        const response = await api.get("/rest-home/semilogy/attachments", {
          params: { semiology_form_question_answer_id },
        });

        const { attachments } = response.data;

        this.attachments = attachments;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async createAttachment(event) {
      try {
        event.preventDefault();

        this.loading = true;

        let attachmentForm = document.getElementById("attachment");

        const { semiology_form_question_answer_id, description } = this;

        const formData = new FormData();

        let attachment = attachmentForm.files[0];

        if (!attachment) {
          this.loading = false;
          this.errors = [
            { id: this.errors.length, message: "Informe o anexo" },
          ];
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
          "application/pdf",
        ];

        if (!allowedMimes.includes(attachment.type)) {
          this.loading = false;
          this.errors = [
            { id: this.errors.length, message: "Formato de anexo inválido" },
          ];
          return;
        }

        var limitSize = 10 * 1024 * 1024;

        if (attachment.size > limitSize) {
          this.loading = false;
          this.errors = [
            { id: this.errors.length, message: "Suportado até 10MB" },
          ];
          return;
        }

        formData.append(
          "semiology_form_question_answer_id",
          semiology_form_question_answer_id
        );
        formData.append("description", description);
        formData.append("attachment", attachment, attachment.name);
        formData.append("type", attachment.type);

        const response = await api.post(
          "/rest-home/semilogy/attachment",
          formData
        );

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.description = "";
          this.errors = [];
          this.getAttachments();
          document.getElementById("attachment").value = "";
          this.$bvModal.hide("createAttachment");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteAttachment(id) {
      try {
        this.loading = true;

        let data = { id };

        const response = await api.delete("/rest-home/semilogy/attachment", {
          data,
        });

        const { error, message, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.getAttachments();
          this.errors = [];
          this.$emit("action");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
